var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register-body"},[_c('a-result',{attrs:{"status":"success","title":_vm.$t('scope.text_352'),"subTitle":_vm.title},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.login}},[_vm._v(_vm._s(_vm.$t('scope.text_353')))])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }